/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Emission details.
 * @export
 * @interface Emission
 */
export interface Emission {
    /**
     * 
     * @type {string}
     * @memberof Emission
     */
    emissionId: string;
    /**
     * 
     * @type {string}
     * @memberof Emission
     */
    emissionStatus: string;
    /**
     * 
     * @type {string}
     * @memberof Emission
     */
    emissionEventType: string;
    /**
     * 
     * @type {Date}
     * @memberof Emission
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof Emission
     */
    emissionConfirmedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Emission
     */
    lastUpdatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Emission
     */
    endTime: Date;
    /**
     * 
     * @type {number}
     * @memberof Emission
     */
    lastEmissionRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Emission
     */
    emissionSource?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Emission
     */
    emissionLatitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Emission
     */
    emissionLongitude?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Emission
     */
    classification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Emission
     */
    companyEventId?: string | null;
}

/**
 * Check if a given object implements the Emission interface.
 */
export function instanceOfEmission(value: object): value is Emission {
    if (!('emissionId' in value) || value['emissionId'] === undefined) return false;
    if (!('emissionStatus' in value) || value['emissionStatus'] === undefined) return false;
    if (!('emissionEventType' in value) || value['emissionEventType'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('emissionConfirmedAt' in value) || value['emissionConfirmedAt'] === undefined) return false;
    if (!('lastUpdatedAt' in value) || value['lastUpdatedAt'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function EmissionFromJSON(json: any): Emission {
    return EmissionFromJSONTyped(json, false);
}

export function EmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Emission {
    if (json == null) {
        return json;
    }
    return {
        
        'emissionId': json['emissionId'],
        'emissionStatus': json['emissionStatus'],
        'emissionEventType': json['emissionEventType'],
        'startTime': (new Date(json['startTime'])),
        'emissionConfirmedAt': (new Date(json['emissionConfirmedAt'])),
        'lastUpdatedAt': (new Date(json['lastUpdatedAt'])),
        'endTime': (new Date(json['endTime'])),
        'lastEmissionRate': json['lastEmissionRate'] === undefined ? undefined : json['lastEmissionRate'] === null ? null : json['lastEmissionRate'],
        'emissionSource': json['emissionSource'] === undefined ? undefined : json['emissionSource'] === null ? null : json['emissionSource'],
        'emissionLatitude': json['emissionLatitude'] === undefined ? undefined : json['emissionLatitude'] === null ? null : json['emissionLatitude'],
        'emissionLongitude': json['emissionLongitude'] === undefined ? undefined : json['emissionLongitude'] === null ? null : json['emissionLongitude'],
        'classification': json['classification'] === undefined ? undefined : json['classification'] === null ? null : json['classification'],
        'companyEventId': json['companyEventId'] === undefined ? undefined : json['companyEventId'] === null ? null : json['companyEventId'],
    };
}

export function EmissionToJSON(json: any): Emission {
    return EmissionToJSONTyped(json, false);
}

export function EmissionToJSONTyped(value?: Emission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emissionId': value['emissionId'],
        'emissionStatus': value['emissionStatus'],
        'emissionEventType': value['emissionEventType'],
        'startTime': value['startTime'].toISOString(),
        'emissionConfirmedAt': value['emissionConfirmedAt'].toISOString(),
        'lastUpdatedAt': value['lastUpdatedAt'].toISOString(),
        'endTime': value['endTime'].toISOString(),
        'lastEmissionRate': value['lastEmissionRate'],
        'emissionSource': value['emissionSource'],
        'emissionLatitude': value['emissionLatitude'],
        'emissionLongitude': value['emissionLongitude'],
        'classification': value['classification'],
        'companyEventId': value['companyEventId'],
    };
}

